// istanbul ignore file
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useEffect, useRef, useState } from 'react'
import Map, { type AMIMarkerData } from '../../Maps/Maps'
import BasicTabs from './DeviceTable/DeviceListAmi'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ListIcon from '@mui/icons-material/List'
import MapIcon from '@mui/icons-material/Map'
import { type RootState } from '../../../store'
import { useSelector } from 'react-redux'
import LanguageStrings from '../../../i18n/locales'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Grid } from '@mui/material'

function generateOutputArray (markers: any[]): any {
  return markers.map((obj) => {
    return {
      assetName: obj.assetName,
      location: {
        lat: obj.latitude,
        lng: obj.longitude
      },
      severity: obj.severity,
      assetId: obj.assetId
    }
  })
}

const Alarm = (props: any): any => {
  const AlarmStrings = LanguageStrings().AMIDataCollectionStrings.topIssues
  const totalIssueCount = useSelector(
    (state: RootState) => state.totalIssuesCount
  )
  const issuesTabRef = useRef<any>(null)
  const [issuesTabHeight, setIssuesTabHeight] = useState(0)
  const [alignment, setAlignment] = props.alignmentObj
  let outputArray: Array<{
    assetName: any
    location: { lat: any, lng: any }
    severity: string
    assetId: string
  }> = []
  if (props.markers?.alarmData != null) {
    outputArray = generateOutputArray(props.markers.alarmData)
  }
  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ): any => {
    if (newAlignment !== alignment) {
      setAlignment(newAlignment)
    }
  }
  useEffect(() => {
    // istanbul ignore next
    if (alignment === 'map' && issuesTabRef.current !== undefined) {
      setIssuesTabHeight(issuesTabRef.current.clientHeight)
    }
  }, [alignment, issuesTabHeight])

  const markers: AMIMarkerData[] = outputArray

  const MapMemoized = React.useMemo(() => { return <Map AMIMarkers={markers} /> }, [])

  const toggleviews = (): any => {
    // istanbul ignore else
    if (alignment === 'list') {
      return (
        <BasicTabs
          compHeight={props.height}
          issuesTabHeight={issuesTabHeight}
        />
      )
    } else {
      return (
        <div style={ { height: '100%' } }>
          <div id='issues-tab' ref={issuesTabRef}>
            <div id='issues-progress'>
            <Card
                className={'defaultCards ' + 'defaultCardBorder '}
                sx={{ height: '70px', width: '170px !important', marginLeft: '15px' }}
              >
                <CardContent
                >
                  <div style={{ marginTop: '0.8em' }}>
                    <Typography variant="button" component="div" style={{ fontSize: 14, letterSpacing: '2px', fontWeight: '6' }}>
                      {AlarmStrings.activeIssues}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
          </div>
        </div>
        <div id='MapCardAmi' style={{ height: `calc(${props.height}px - 170px)` }}>
          {/* <Map AMIMarkers={markers} /> */}
          {MapMemoized}
        </div>
      </div>
      )
    }
  }
  return (
    <Grid
      container
      sx={{
        borderRadius: '10px',
        backgroundColor: '#272727',
        color: '#f0f0f0'
      }}
    >
      <div className="top-issues-header">
        <div style={{ fontSize: '18px' }}>
          TOP ISSUES LIST ({totalIssueCount})
        </div>
        <div style={{ backgroundColor: '#505050', borderRadius: '4px' }}>
          <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="text alignment"
            sx={{
              padding: '2px',
              backgroundColor: '#505050',
              border: 'none'
            }}
          >
            <ToggleButton
              sx={{ border: 'none', borderRadius: '4px' }}
              value="list"
              aria-label="left aligned"
              data-testid="left aligned"
              disabled={alignment === 'list'}
            >
              <ListIcon />
            </ToggleButton>
            <ToggleButton
              sx={{ border: 'none', borderRadius: '4px' }}
              value="map"
              aria-label="right aligned"
              data-testid="right aligned"
              disabled={alignment === 'map'}
            >
              <MapIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
      <div style={{ width: '100%' }}>{toggleviews()}</div>
    </Grid>
  )
}

export default Alarm
